import { AppState } from 'Store'

const selectItems = (state: AppState) => state.orders.blockProduct.blockProducts
const selectRequestParams = (state: AppState) => state.orders.blockProduct.requestParams
const selectVisibleDrawer = (state: AppState) => state.orders.blockProduct.visibleDrawer
const selectItem = (state: AppState) => state.orders.blockProduct.product

export const blockProductGroupsSelector = {
	selectItems,
	selectRequestParams,
	selectVisibleDrawer,
	selectItem,
}
